<template>
  <div class="home-container">
    <!-- <div
      class="home-carousel"
      @mouseover="pauseCarousel"
      @mouseout="resumeCarousel"
    >
      <div class="img-carausel">
        <div class="carousel-container">
          <transition-group name="slide" mode="out-in" v-if="slides.length > 0">
            <div :key="currentSlide.id" class="slide">
              <div class="image-wrapper">
                <img :src="currentSlide.image" :alt="currentSlide.alt" />
              </div>
            </div>
          </transition-group>
        </div>
      </div>

      <div class="indicators">
        <span
          v-for="(slide, index) in slides"
          :key="slide.id"
          :class="['indicator-dot', { active: slide.id === currentIndex }]"
          @click="goToSlide(slide.id)"
          v-if="slides.length > 0"
        ></span>
      </div>
      <div class="btn-right-carousel" @click="slideToRight">
        <i class="fa fa-chevron-right"></i>
      </div>
      <div class="btn-left-carousel" @click="slideToLeft">
        <i class="fa fa-chevron-left"></i>
      </div>
      <div class="btn-edit-carousel" v-if="$store.state.role_id == 1">
        <button @click="openEditCarousel">Edit Carousel</button>
      </div>
    </div>
    <div v-if="editCarousel">
      <modal-carousel
        :images="slides"
        @closeModalCarousel="closeEditCarousel"
      />
    </div> -->

    <!-- Carousel Desktop -->
    <CarouselDesktop
      v-if="slides.length > 0"
      class="desktop-carousel"
      :images="slides"
      @closeModalCarousel="closeEditCarousel"
    />

    <!-- Carousel Mobile -->
    <CarouselMobile
      v-if="slides.length > 0"
      class="mobile-carousel"
      :slides="slides"
      @closeModalCarousel="closeEditCarousel"
    />

    <div class="home-divider">
      <div class="divider-line-2"></div>
      Semua Kegiatan Usaha
      <div class="divider-line-2"></div>
    </div>

    <div class="home-wrapper">
      <div class="home-section-container">
        <div class="home-section" v-if="listUsaha">
          <div v-for="list in listUsaha" class="btn-kbli-home">
            <div
              @click="() => goToLevel1(list.id)"
              style="width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center;"
            >
              <div class="icon-kbli">
                <img
                  :src="require(`~/assets/img/icons/${list.id}.png`)"
                  alt=""
                />
              </div>
              <div class="desc-kbli w-full col-elipsis">{{ list.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="home-divider">
      <div class="divider-line-2"></div>
      Perusahaan Terakhir Dilihat
      <div class="divider-line-2"></div>
    </div>

    <div class="home-wrapper">
      <div class="home-section-container">
        <div class="home-section" v-if="vendorList">
          <div class="home-list-container">
            <div v-for="vendor in vendorList" class="home-list">
              <CompanyCard
                :classCompany="'home-card-company'"
                :onClick="vendor => openModal(vendor)"
                :vendor="vendor"
              />
              <!-- <CompanyCard
                :onClick="openModal"
                :csiScore="3"
                :companyName="'Nama Perusahaan'"
                :grade="80"
                :k3lValue="'60'"
                :k3lDesc="'Medium - B1'"
                :kplhValue="'80'"
                :kplhDesc="'Tidak Lulus'"
              /> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    CompanyCard: () => import('@/components/Organism/CompanyCard.vue'),
    ModalCarousel: () => import('@/components/ModalCarousel.vue'),
    CarouselDesktop: () => import('@/components/Organism/CarouselDesktop.vue'),
    CarouselMobile: () => import('@/components/Organism/CarouselMobile.vue'),
  },
  data() {
    return {
      currentIndex: 0,
      intervalId: null,
      intervalDuration: 7000,

      subSeach: [],
      selectedSub: [],
      listUsaha: [
        {
          name: 'Pertanian, Kehutanan, dan Perikanan',
          id: '1',
          sub: [
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
          ],
        },
        {
          name: 'Pertambangan dan Penggalian',
          id: '2',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Industri Pengolahan',
          id: '3',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Pengadaan Listrik, Gas, Uap/Air Panas dan Udara',
          id: '4',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Treatmen Air, Treatment Air Limbah, Treatment Udara',
          id: '5',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Konstruksi',
          id: '6',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Perdagangan Besar Dan Eceran, Reparasi dan Perbaikan',
          id: '7',
          sub: [
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
          ],
        },
        {
          name: 'Pengangkutan dan Pergudangan',
          id: '8',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Penyediaan Akomodasi dan Penyediaan Makanan dan Minuman',
          id: '9',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Informasi dan Komunikasi',
          id: '10',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Keuangan dan Asuransi',
          id: '11',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Real Estat',
          id: '12',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Profesional, Ilmiah dan Teknis',
          id: '13',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Penyewaan dan Sewa Guna Usaha dan Jasa',
          id: '14',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Administrasi Pemerintahan Pusat',
          id: '15',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Pendidikan',
          id: '16',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Kesehatan Manusia dan Aktivitas Mesin',
          id: '17',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Kesenian, Hiburan dan Rekreasi',
          id: '18',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Jasa Lainnya',
          id: '19',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name:
            'Aktivitas Rumah Tangga Sebagai Pemberi Kerja kepada masyarakat',
          id: '20',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Badan International dan Nasional',
          id: '21',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
      ],
      listUsahaMaster: null,
      modalOpen: false,
      editCarousel: false,
      vendorList: [],
    }
  },
  created() {
    // this.getKbliData()
    // this.getKbliMaster()
    const vendors = JSON.parse(localStorage.getItem('vendors'))
    if (vendors && vendors.length > 0) {
      this.vendorList = vendors
      console.log('vendors home: ', vendors)
    }

    const slides = this.$get(this.$store, 'state.slides.id', 0)
    this.currentIndex = slides
  },
  computed: {
    currentSlide() {
      return this.slides[this.currentIndex]
    },
    slides() {
      const slides = this.$store.state.slides

      return slides
    },
  },
  mounted() {
    this.startCarousel()
  },
  beforeDestroy() {
    this.stopSlideInterval()
  },

  methods: {
    goToSlide(index) {
      this.currentIndex = index
    },
    slideToLeft() {
      this.currentIndex =
        (this.currentIndex - 1 + this.slides.length) % this.slides.length
    },
    slideToRight() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length
    },
    startCarousel() {
      this.intervalId = setInterval(() => {
        this.slideToRight()
      }, this.intervalDuration)
    },
    stopSlideInterval() {
      clearInterval(this.intervalId)
    },

    openEditCarousel() {
      this.editCarousel = true
    },

    closeEditCarousel() {
      this.editCarousel = false
    },

    pauseCarousel() {
      this.stopSlideInterval()
    },

    resumeCarousel() {
      this.startCarousel()
    },

    async openModal(vendor) {
      await this.$store.commit('level1/setData', {
        name: 'vendorId',
        value: vendor.id,
      })
      await this.$store.commit('level1/GET_PROFILE_DATA', {
        id: vendor.id,
        onSuccess: () => {
          this.$store.commit('level1/GET_INFO_DATA', 'informasi')
        },
      })
      this.$store.commit('modalStore/openModal', {
        name: 'profile',
      })
    },
    closeModal() {
      this.modalOpen = false
    },
    async goToLevel1(id) {
      const parentKbli = id && `&kbli_parent=${id}`

      await this.$store.commit('level1/GET_VENDOR', {
        query: { kbliParent: parentKbli },
      })

      await this.$router.push('search-result')
    },
  },
}
</script>
